import React from 'react';

export default class ParallaxItem extends React.Component {
    constructor(props,context) {
        super(props,context);
        this.props=props;
        this.context=context;
    }
    getHeightPercent() {
        if(this.props.extraHeight) {
            return (100+parseFloat(this.props.extraHeight))+"%";            
        } else {
            return "100%";
        }
    }
    getTopPos() {
        var completed = this.context.parallaxCompleted;
        var extraheight = parseFloat(this.props.extraHeight)/100;
        return (100*completed*extraheight/(1 + extraheight))+"%";
    }
    render() {
        return(
            <div style={{
                position:"absolute",
                bottom:0,
                left:0,
                right:0,
                width:"100%",
                transform:"translateY("+this.getTopPos()+") translateZ(0)",
                height:this.getHeightPercent(),
                willChange: 'transform'
            }}>
               <div style={{ 
                   
                   height:"100%",
                   width:"100%"
               }}>
                   {this.props.children}
               </div>
            </div>
        )    
    }
}

ParallaxItem.contextTypes = {
    parallaxCompleted: React.PropTypes.number.isRequired
};


// WEBPACK FOOTER //
// ./src/js/components/ParallaxItem/ParallaxItem.jsx